import {Activity, ActivityType} from '../activity';
import {Definition} from '../definition';
import {ActorType} from '../enumerations/actor-type';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class CreateResourceActivity extends Activity {
  public ResourceType: string;
  public Advanced: boolean;
  public CreatedResourceIdTarget: string;
  public CheckForConflict: boolean;
  public ConflictFilter: string;
  public FailOnConflict: boolean;
  public ConflictingResourceIdTarget: string;
  public QueryResources: boolean;
  public QueriesTable: Definition[];
  public AttributesTable: Definition[];
  public ActivityExecutionCondition: string;
  public Iteration: string;
  public ActorType: ActorType;
  public ActorString: string;
  public ApplyAuthorizationPolicy: boolean;

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.CreateResource);
    this._properties['ResourceType'] = ActivityPropertyDataType.STRING;
    this._properties['Advanced'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['CreatedResourceIdTarget'] = ActivityPropertyDataType.STRING;
    this._properties['CheckForConflict'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['ConflictFilter'] = ActivityPropertyDataType.STRING;
    this._properties['FailOnConflict'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['ConflictingResourceIdTarget'] = ActivityPropertyDataType.STRING;
    this._properties['QueryResources'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['QueriesTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this._properties['AttributesTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['Iteration'] = ActivityPropertyDataType.STRING;
    this._properties['ActorType'] = ActivityPropertyDataType.ACTOR_TYPE;
    this._properties['ActorString'] = ActivityPropertyDataType.STRING;
    this._properties['ApplyAuthorizationPolicy'] = ActivityPropertyDataType.BOOLEAN;
    this._advancedProperties = [
      'CreatedResourceIdTarget',
      'CheckForConflict',
      'ConflictFilter',
      'FailOnConflict',
      'ConflictingResourceIdTarget',
      'QueryResources',
      'QueriesTable',
      'ActivityExecutionCondition',
      'Iteration',
      'ActorType',
      'ActorString',
      'ApplyAuthorizationPolicy',
    ];
    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();
    if (this.QueryResources === false) {
      this.QueriesTable = null;
    }

    if (this.ActorType !== ActorType.Resolve && this.ActorType !== ActorType.Account) {
      this.ActorString = null;
    }

    if (this.CheckForConflict === false) {
      this.ConflictFilter = null;
      this.ConflictingResourceIdTarget = null;
      this.FailOnConflict = null;
    }
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('create-resource', this.dialogConfig);
  }
}
